import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebaseConfig';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

// ── Emoji selector data ───────────────────────────────────────────────────────

const EMOJI_CATEGORIES = {
  Faces: ['😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🥸','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕'],
  Animals: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐔','🐧','🐦','🐤','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞','🐜','🦟','🦗','🕷','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍','🦧','🐘','🦛','🦏','🐪','🐫','🦒','🦘','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕','🐩','🦮','🐈','🐓','🦃','🦚','🦜','🦢','🦩','🕊','🐇','🦝','🦨','🦡','🦦','🦥','🐁','🐀','🐿','🦔'],
  Food: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶','🌽','🥕','🧄','🧅','🥔','🍠','🥐','🥯','🍞','🥖','🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🌮','🌯','🥙','🧆','🥚','🍜','🍝','🍛','🍣','🍱','🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥮','🍢','🧁','🍰','🎂','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🥜','🍯','🧃','🥤','🧋','☕','🍵','🧉','🍺','🍻','🥂','🍷','🥃','🍸','🍹','🍾'],
  Objects: ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🏓','🏸','🥅','⛳','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛷','⛸','🥌','🎿','⛷','🏂','🪂','🏋️','🤼','🤸','⛹️','🤺','🏇','🧘','🎪','🎭','🎨','🎬','🎤','🎧','🎼','🎹','🥁','🎷','🎺','🎸','🪕','🎻','🎲','♟','🎯','🎳','🎮','🎰','🧩','🚗','🚕','🚙','🚌','🚎','🏎','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🏍','🛵','🚲','🛴','🛺','🚁','🛸','✈️','🚀','🛶','⛵','🚤','🛥','🛳','⛴','🚢','⚓','🗺','🧭','🏔','⛰','🌋','🗻','🏕','🏖','🏜','🏝','🏞','🏟','🏛','🏗','🧱','🏘','🏚','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨','🏩','🏪','🏫','🏬','🏭','🏯','🏰','💒','🗼','🗽'],
};

function EmojiPicker({ value, onChange }) {
  const [activeCategory, setActiveCategory] = useState('Faces');
  const categories = Object.keys(EMOJI_CATEGORIES);

  return (
    <div className="emoji-picker">
      <div className="emoji-picker__tabs">
        {categories.map(cat => (
          <button
            key={cat}
            className={`emoji-picker__tab${activeCategory === cat ? ' active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="emoji-picker__grid">
        {EMOJI_CATEGORIES[activeCategory].map(emoji => (
          <button
            key={emoji}
            className={`emoji-picker__btn${value === emoji ? ' selected' : ''}`}
            onClick={() => onChange(emoji)}
            aria-label={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
      {value && (
        <div className="emoji-picker__selected">
          Selected: <span style={{ fontSize: '1.8rem' }}>{value}</span>
        </div>
      )}
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────

export default function PlayerPortal({ gamePin, onBack }) {
  const [gameState, setGameState]       = useState(null);
  const [playerId]                      = useState(() => 'user_' + Math.random().toString(36).substring(2, 9));
  const [myAnswer, setMyAnswer]         = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [uploading, setUploading]       = useState(false);
  const [joined, setJoined]             = useState(false);
  const [error, setError]               = useState('');

  useEffect(() => {
    let didJoin = false;
    const unsub = onSnapshot(doc(db, 'games', gamePin), async (snap) => {
      if (!snap.exists()) { setError('Game not found. Check the PIN and try again.'); return; }
      const data = snap.data();
      setGameState(data);
      if (!didJoin) {
        didJoin = true;
        setJoined(true);
        await updateDoc(doc(db, 'games', gamePin), { paxCount: (data.paxCount || 0) + 1 });
      }
    });
    return () => unsub();
  }, [gamePin]);

  useEffect(() => {
    setHasSubmitted(false);
    setMyAnswer('');
    setSelectedOptions([]);
  }, [gameState?.currentQuestionIndex]);

  const submitAnswer = async (finalAns) => {
    const ans = finalAns !== undefined ? finalAns : myAnswer;
    if (ans === '' || (Array.isArray(ans) && ans.length === 0)) {
      return alert('Please provide an answer before submitting.');
    }
    const idx = gameState.currentQuestionIndex;
    const existing = gameState.responses?.[idx] || [];
    await updateDoc(doc(db, 'games', gamePin), {
      [`responses.${idx}`]: [...existing, { userId: playerId, answer: Array.isArray(ans) ? ans.join(', ') : ans }],
    });
    setHasSubmitted(true);
  };

  const toggleOption = (opt) => {
    setSelectedOptions(prev =>
      prev.includes(opt) ? prev.filter(o => o !== opt) : [...prev, opt]
    );
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const storageRef = ref(storage, `answers/${gamePin}/${playerId}_${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      await submitAnswer(url);
    } catch {
      alert('Upload failed. Please try again.');
    }
    setUploading(false);
  };

  if (error) {
    return (
      <div className="page-center">
        <div className="container" style={{ maxWidth: 420, textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: 12 }}>❌</div>
          <p style={{ fontWeight: 700, marginBottom: 8 }}>{error}</p>
          <button className="btn btn--ghost" onClick={onBack}>← Go Back</button>
        </div>
      </div>
    );
  }

  if (!gameState) {
    return (
      <div className="page-center">
        <div className="container" style={{ maxWidth: 420, textAlign: 'center' }}>
          <div className="lobby-pulse" style={{ margin: '0 auto 16px' }} />
          <p className="muted">Connecting to game <strong>{gamePin}</strong>...</p>
        </div>
      </div>
    );
  }

  const currentQ = gameState.questions[gameState.currentQuestionIndex];

  return (
    <div className="page-center" style={{ justifyContent: 'flex-start', paddingTop: 24 }}>
      <div className="container" style={{ maxWidth: 480 }}>
        {/* Header */}
        <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
          <button className="btn btn--ghost btn--sm" onClick={onBack}>← Leave</button>
          <div className="text-center">
            <div style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Room</div>
            <div style={{ fontSize: '1.4rem', fontWeight: 900, letterSpacing: '0.1em', color: 'var(--brand)' }}>{gamePin}</div>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textAlign: 'right' }}>
            <div>ID</div>
            <div style={{ fontWeight: 700 }}>{playerId.substring(5)}</div>
          </div>
        </div>

        {/* Lobby */}
        {gameState.status === 'lobby' && (
          <div className="card text-center" style={{ padding: '48px 32px' }}>
            <div style={{ fontSize: '3rem', marginBottom: 16 }}>🎮</div>
            <div className="section-title" style={{ marginBottom: 8 }}>You're in!</div>
            <p className="muted" style={{ marginBottom: 20 }}>
              {joined ? `${gameState.paxCount} participant${gameState.paxCount !== 1 ? 's' : ''} connected.` : 'Joining...'}
            </p>
            <div className="flex items-center justify-center" style={{ gap: 10 }}>
              <span className="lobby-pulse" />
              <span className="muted">Waiting for the host to start...</span>
            </div>
          </div>
        )}

        {/* Active question — not yet submitted */}
        {gameState.status === 'question' && currentQ && !hasSubmitted && (
          <div className="card">
            <div className="flex items-center justify-between" style={{ marginBottom: 16 }}>
              <span className="question-item__type">{currentQ.type}</span>
              <span className="muted" style={{ fontSize: '0.85rem' }}>
                Q{gameState.currentQuestionIndex + 1} / {gameState.questions.length}
              </span>
            </div>

            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 24, lineHeight: 1.4 }}>
              {currentQ.prompt}
            </h2>

            {/* Yes / No */}
            {currentQ.type === 'yes_no' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <button className="btn btn--success btn--lg" onClick={() => submitAnswer('Yes')}>✓ Yes</button>
                <button className="btn btn--danger btn--lg" onClick={() => submitAnswer('No')}>✗ No</button>
              </div>
            )}

            {/* Scale */}
            {currentQ.type === 'scale' && (
              <div className="slider-wrap">
                <div className="slider-value">{myAnswer || 50}</div>
                <input
                  type="range" min="1" max="100"
                  className="slider"
                  style={{ '--val': `${((myAnswer || 50) - 1) / 99 * 100}%` }}
                  value={myAnswer || 50}
                  onChange={e => setMyAnswer(Number(e.target.value))}
                />
                <div className="flex justify-between muted" style={{ fontSize: '0.8rem', marginBottom: 20 }}>
                  <span>1</span><span>100</span>
                </div>
                <button className="btn btn--primary btn--full" onClick={() => submitAnswer(myAnswer || 50)}>
                  Submit
                </button>
              </div>
            )}

            {/* Single MCQ */}
            {currentQ.type === 'single_mcq' && (
              <div>
                {currentQ.options.map((opt, i) => (
                  <button key={i} className="option-btn" onClick={() => submitAnswer(opt)}>
                    <span style={{ marginRight: 10, color: 'var(--brand)', fontWeight: 800 }}>
                      {String.fromCharCode(65 + i)}.
                    </span>
                    {opt}
                  </button>
                ))}
              </div>
            )}

            {/* Multi MCQ */}
            {currentQ.type === 'multi_mcq' && (
              <div>
                {currentQ.options.map((opt, i) => (
                  <button
                    key={i}
                    className={`option-btn${selectedOptions.includes(opt) ? ' selected' : ''}`}
                    onClick={() => toggleOption(opt)}
                  >
                    <span style={{ marginRight: 10, color: selectedOptions.includes(opt) ? 'var(--brand)' : 'var(--text-muted)', fontWeight: 800 }}>
                      {selectedOptions.includes(opt) ? '☑' : '☐'}
                    </span>
                    {opt}
                  </button>
                ))}
                <button
                  className="btn btn--primary btn--full"
                  style={{ marginTop: 8 }}
                  disabled={selectedOptions.length === 0}
                  onClick={() => submitAnswer(selectedOptions)}
                >
                  Submit Selection
                </button>
              </div>
            )}

            {/* Paragraph */}
            {currentQ.type === 'paragraph' && (
              <div>
                <textarea
                  className="input"
                  placeholder="Type your answer here..."
                  value={myAnswer}
                  onChange={e => setMyAnswer(e.target.value)}
                  style={{ minHeight: 120, marginBottom: 12 }}
                />
                <button
                  className="btn btn--primary btn--full"
                  disabled={!myAnswer.trim()}
                  onClick={() => submitAnswer()}
                >
                  Submit
                </button>
              </div>
            )}

            {/* Photo */}
            {currentQ.type === 'photo' && (
              <div className="text-center">
                <label style={{
                  display: 'block',
                  border: '2px dashed var(--border)',
                  borderRadius: 'var(--radius)',
                  padding: '32px 20px',
                  cursor: 'pointer',
                  marginBottom: 12,
                  transition: 'border-color 0.15s',
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: 8 }}>📷</div>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>Tap to select a photo</div>
                  <div className="muted" style={{ fontSize: '0.85rem' }}>JPG, PNG, GIF supported</div>
                  <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} />
                </label>
                {uploading && (
                  <div className="flex items-center justify-center" style={{ gap: 8 }}>
                    <span className="lobby-pulse" />
                    <span className="muted">Uploading...</span>
                  </div>
                )}
              </div>
            )}

            {/* Emoji Selector */}
            {currentQ.type === 'emoji_selector' && (
              <div>
                <EmojiPicker value={myAnswer} onChange={setMyAnswer} />
                <button
                  className="btn btn--primary btn--full"
                  style={{ marginTop: 16 }}
                  disabled={!myAnswer}
                  onClick={() => submitAnswer()}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        )}

        {/* Submitted — waiting */}
        {gameState.status === 'question' && hasSubmitted && (
          <div className="submitted-state card">
            <div className="submitted-state__icon">✅</div>
            <div className="submitted-state__title">Response Submitted!</div>
            <p className="muted">Waiting for the host to move to the next question.</p>
          </div>
        )}

        {/* Game ended */}
        {gameState.status === 'ended' && (
          <div className="card text-center" style={{ padding: '48px 32px' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>🏁</div>
            <div className="section-title" style={{ marginBottom: 8 }}>Game Over!</div>
            <p className="muted" style={{ marginBottom: 24 }}>Thanks for participating. Your responses have been recorded.</p>
            <button className="btn btn--ghost" onClick={onBack}>← Back to Menu</button>
          </div>
        )}
      </div>
    </div>
  );
}
